import React from "react";
import { Product } from "src/interfaces";
// import dynamic from "next/dynamic";
import PageHeading from "@Components/PageHeading";
import useAuthorization from "@Hooks/useAuth";
import auth from "@Utils/auth";
import getClient from "@Lib/auth/utils/oidc-client";
import { makeResponse } from "@Hooks/useRequest";
import { getProducts } from "./api/products";
import { SWRConfig } from "swr";
import ProductsSiteLayout from "@Components/layouts/ProductsSiteLayout";
import ProductList from "@Components/product/ProductList";
import { AxiosError } from "axios";
export interface ProductsPageProps {
  fallback: {
    [req: string]: Product[];
  };
}

// const ProductListLoading = () => <div>...</div>;

// const ProductList = dynamic(
//   () => import("src/components/product/ProductList"),
//   {
//     loading: ProductListLoading,
//   },
// );

const ProductsPage = ({ fallback }: ProductsPageProps) => {
  const [show, setShow] = React.useState(false);
  const { client } = useAuthorization({ register: true });

  React.useEffect(() => {
    setShow(Boolean(!!client));
  }, [client]);

  return (
    <ProductsSiteLayout>
      <SWRConfig value={{ fallback }}>
        <PageHeading text="Services"></PageHeading>
        {show && <ProductList />}
      </SWRConfig>
    </ProductsSiteLayout>
  );
};

export async function getStaticProps() {
  let products: Product[] = [];
  const req = {
    url: "/api/products",
  };

  try {
    const clientProvider = getClient(auth.settings);
    const client = await clientProvider();
    console.log("Obtaining access_token");

    const tokens = await client.grant({ grant_type: "client_credentials" });

    const access_token = tokens.access_token;

    try {
      console.log(
        `Fetching products from: ${process.env.APIS__PUBLIC_WEBSITE}/products`,
      );
      products = await getProducts(access_token);
    } catch (err) {
      const error = err as AxiosError<unknown>;
      console.error(
        "Error when fetching products",
        (error.response && error.response.headers["www-authenticate"]) ||
          error.message,
      );
    }
  } catch (err) {
    console.error("Could not attain grant");
  }

  return {
    props: {
      fallback: {
        [JSON.stringify(req)]: makeResponse(products, req, "Initial Data"),
      },
    },
  };
}

export default ProductsPage;
